import React, { FC } from 'react'
import { animated } from 'react-spring'
import styled, { keyframes } from 'styled-components'
import SvgIcon from '../../../../design-system/Icon/SvgIcon'

type Props = { active: boolean }

export const AnimatedArrowWithBorder: FC<Props> = ({ active }) => {
  return (
    <IconBorder $active={active}>
      <Icon $active={active} />
    </IconBorder>
  )
}

const IconBorder = styled.div<{ $active: boolean }>`
  transition: border-color 300ms ease;

  border: 1px dashed ${props => props.theme.colors.greyDark};
  border-color: ${props => props.$active && props.theme.colors.black};

  border-radius: 8px;

  display: flex;
  justify-content: center;
  align-items: center;

  height: 48px;
  width: 48px;

  overflow: hidden;
`

const arrowLoopAnimation = keyframes`
	0% { margin-bottom: 0px; opacity: 1 }
	60% { margin-bottom: 0px; opacity: 1 }
	75.23% { margin-bottom: 80px; opacity: 0.3 }
	75.2300001% { margin-bottom: -80px; opacity: 0.3 }
	85.46% { margin-bottom: -80px; opacity: 0.3 }
	100% { margin-bottom: 0px; opacity: 1 }
`

const Icon = styled(animated(SvgIcon)).attrs({ name: 'arrowUp' })<{ $active: boolean }>`
  transform: scale(${props => (props.$active ? 1.03 : 1)});
  transition: transform 300ms;

  .primary {
    stroke: ${props => props.theme.colors.greyDark};
    stroke: ${props => props.$active && props.theme.colors.black};
  }

  animation: ${arrowLoopAnimation} 4300ms;
  animation-iteration-count: infinite;
  animation-timing-function: ease-out;
`
